import { z } from "zod";
import { TFunction } from "i18next";

export const createSignupSchema = (t: TFunction) =>
  z.object({
    username: z
      .string()
      .min(5, t("validationUsernameMinLength"))
      .max(20, t("validationUsernameMaxLength")),
    email: z
      .string()
      .email(t("validationInvalidEmail"))
      .min(5, t("validationEmailLength"))
      .max(255, t("validationEmailLength")),

    password: z
      .string()
      .min(8, {
        message: t("validationPasswordMinLength"),
      })
      .regex(/[a-zA-Z]/, {
        message: t("validationPasswordMinLength"),
      })
      .regex(/[0-9]/, {
        message: t("validationPasswordMinLength"),
      }),
  });

// Legacy export for backward compatibility
export const SignupSchema = (t: TFunction) =>
  z.object({
    username: z
      .string()
      .min(5, t("validationUsernameMinLength"))
      .max(20, t("validationUsernameMaxLength")),
    email: z
      .string()
      .email(t("validationInvalidEmail"))
      .min(5, t("validationEmailLength"))
      .max(255, t("validationEmailLength")),

    password: z
      .string()
      .min(8, {
        message: t("validationPasswordMinLength"),
      })
      .regex(/[a-zA-Z]/, {
        message: t("validationPasswordMinLength"),
      })
      .regex(/[0-9]/, {
        message: t("validationPasswordMinLength"),
      }),
  });

export type SignupModel = z.infer<ReturnType<typeof createSignupSchema>>;
